<template>
    <section class="page-content">
        <RoomDetailComponent/>
        <!-- <OtherRoomsComponent/> -->
    </section>
</template>

<script setup>
    import RoomDetailComponent from '@/components/room/RoomDetailComponent.vue';
    // import OtherRoomsComponent from '@/components/room/OtherRoomsComponent.vue';
    window.scrollTo(0, 0);
</script>

<style scoped>
    /*  */
</style>